import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:false
};


export default {
    path: '/notice',
    name: 'notice',
    redirect: {
        name: 'noticeList'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/notice/noticeList',
            name: 'noticeList',
            meta: {
                ...meta,
                title: '个人经办'
            },
            component: () => import('@/pages/notice/noticeList.vue')
        },
        {
            path: '/notice/noticeEdit',
            name: 'noticeEdit',
            meta: {
                ...meta,
                title: '编辑公告'
            },
            component: () => import('@/pages/notice/noticeEdit.vue')
        },
        {
            path: '/notice/noticeEdit',
            name: 'noticeAdd',
            meta: {
                ...meta,
                title: '新增公告'
            },
            component: () => import('@/pages/notice/noticeEdit.vue')
        },
        {
            path: '/notice/noticeTypeList',
            name: 'noticeTypeList',
            meta: {
                ...meta,
                title: '公告类型'
            },
            component: () => import('@/pages/notice/noticeTypeList.vue')
        },
        {
            path: '/notice/noticeTypeEdit/:id',
            name: 'noticeTypeEdit',
            meta: {
                ...meta,
                title: '编辑公告类型'
            },
            component: () => import('@/pages/notice/noticeTypeEdit.vue')
        },
        {
            path: '/notice/noticeTypeEdit',
            name: 'noticeTypeAdd',
            meta: {
                ...meta,
                title: '新增公告类型'
            },
            component: () => import('@/pages/notice/noticeTypeEdit.vue')
        },
        {
            path: '/notice/indexNoticeList',
            name: 'indexNoticeList',
            meta: {
                ...meta,
                title: '公告'
            },
            component: () => import('@/pages/notice/indexNoticeList.vue')
        },
        {
            path: '/notice/indexNoticeDetail',
            name: 'indexNoticeDetail',
            meta: {
                ...meta,
                title: '公告详情'
            },
            component: () => import('@/pages/notice/indexNoticeDetail.vue')
        },{
            path: '/notice/postTodo',
            name: 'oaNotifyPostTodo',
            meta: {
                ...meta,
                title:'公告待办',
            },
            component: () => import('@/pages/notice/oaNotifyPostTodo.vue')
        },        {
            path: '/notice/draft',
            name: 'oaNotifyDraft',
            meta: {
                ...meta,
                title:'公告草稿',
            },
            component: () => import('@/pages/notice/oaNotifyDraft.vue')
        },        {
            path: '/notice/approve',
            name: 'oaNotifyApprove',
            meta: {
                ...meta,
                title:'公告审批',
            },
            component: () => import('@/pages/notice/oaNotifyApprove.vue')
        },{
            path: '/notice/apply',
            name: 'oaNotifyApply',
            meta: {
                ...meta,
                title:'公告申请',
            },
            component: () => import('@/pages/notice/oaNotifyApply.vue')
        },
        {
            path: '/notice/MyPublished',
            name: 'MyPublished',
            meta: {
                ...meta,
                title:'我的发布',
            },
            component: () => import('@/pages/notice/myPublished.vue')
        },
        {
            path: '/notice/MyNotify',
            name: 'MyNotify',
            meta: {
                ...meta,
                title:'已收公告',
            },
            component: () => import('@/pages/notice/myNotice.vue')
        },
        {
            path: '/notice/deletedNotify',
            name: 'deletedNotify',
            meta: {
                ...meta,
                title:'已删公告',
            },
            component: () => import('@/pages/notice/deletedNotify.vue')
        },{
            path: '/notice/myDraft',
            name: 'noticeDraft',
            meta: {
                ...meta,
                title:'我的草稿',
            },
            component: () => import('@/pages/notice/myDraft.vue')
        },{
            path: '/notice/draftEdit',
            name: 'draftEdit',
            meta: {
                ...meta,
                title:'编辑草稿',
            },
            component: () => import('@/pages/notice/draftEdit.vue')
        }
    ]
};
